import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useState, useEffect } from "react";
import { useAppSelector } from "../../app/hooks";
import "react-tabs/style/react-tabs.css";
import ViewEditGroup from "./ViewEditGroup";
import { selectGroups } from "../../features/groups/groupSlice";
import { SubscriptionActiveGroupRedirection } from "../../utils/SubscriptionRedirect";
import useGetLanguage from "../../utils/useGetLanguage";
import { LanguageText } from "../../dictionary/GroupsText";

function EditDeviceIndex() {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });

  const navigate = useNavigate();
  const location = useLocation();
  let { groupid } = useParams();
  const group = useAppSelector(selectGroups).groups[groupid ?? ""];

  useEffect(() => {
    const redirect = SubscriptionActiveGroupRedirection(group);
    if (redirect) {
      navigate(redirect);
    }
  }, [group, navigate]);

  const [tabIndex, setTabIndex] = useState(switchTabFromURL());

  function switchTabFromURL() {
    if (location.pathname.includes("members")) {
      return 1;
    } else if (location.pathname.includes("devices")) {
      return 2;
    } else if (location.pathname.includes("dashboards")) {
      return 3;
    } else if (location.pathname.includes("notifications")) {
      return 4;
    } else if (location.pathname.includes("subscription")) {
      return 5;
    } else if (location.pathname.includes("style")) {
      return 6;
    } else if (location.pathname.includes("auditlogs")) {
      return 7;
    } else {
      return 0;
    }
  }

  return (
    <div className="h-full w-full">
      <Tabs
        forceRenderTabPanel
        /* defaultIndex={switchTabFromURL()} */
        selectedIndex={switchTabFromURL()}
        onSelect={(index) => setTabIndex(index)}
        className="h-full w-full text-black bg-white rounded-lg"
      >
        <TabList className="bg-white rounded border w-full block overflow-x-scroll whitespace-nowrap overflow-y-hidden scrollbar-thin">
          <Tab onClick={() => navigate(".")}>
            {Language?.viewEditGroup?.tabs?.overview}
          </Tab>
          <Tab onClick={() => navigate("./members")}>
            {Language?.viewEditGroup?.tabs?.members}
          </Tab>
          <Tab onClick={() => navigate("./devices")}>
            {Language?.viewEditGroup?.tabs?.devices}
          </Tab>
          <Tab onClick={() => navigate("./dashboards")}>
            {Language?.viewEditGroup?.tabs?.dashboards}
          </Tab>
          <Tab onClick={() => navigate("./notifications")}>
            {Language?.viewEditGroup?.tabs?.notifications}
          </Tab>
          {group && group.owner && (
            <Tab onClick={() => navigate("./subscription")}>
              {Language?.viewEditGroup?.tabs?.subscription}
            </Tab>
          )}
          {group && group.owner && (
            <Tab onClick={() => navigate("./style")}>
              {Language?.viewEditGroup?.tabs?.styles}
            </Tab>
          )}
          {group && group.owner && (
            <Tab onClick={() => navigate("./auditlogs")}>
              {Language?.viewEditGroup?.tabs?.logs}
            </Tab>
          )}
        </TabList>
        <TabPanel>
          <ViewEditGroup />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
        {group && group.owner && (
          <TabPanel>
            <Outlet />
          </TabPanel>
        )}
        {group && group.owner && (
          <TabPanel>
            <Outlet />
          </TabPanel>
        )}
        {group && group.owner && (
          <TabPanel>
            <Outlet />
          </TabPanel>
        )}
      </Tabs>
    </div>
  );
}

export default EditDeviceIndex;
